import React from 'react';

import FlatButton from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import styled from 'styled-components';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledH3 = styled.h3`
  text-align: center;
`;
const StyledP = styled.p`
  text-align: center;
`;
const StyledDialogContainer = styled.div`
  padding: 0.5rem 2rem;
`;

const StyledWarningImg = styled.img`
  height: 50px;
`;

const StyledWarningContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 14px 0 0;
`;

const StyledTextContainer = styled.div`
  padding: 14px 0;
`;

const StyledFormCtaContainer = styled.div`
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
`;

const AutopaySetupWarning = ({
  handleCancel,
  handleContinue,
  fullScreen,
  open,
  paymentType = 'card',
}) => {
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      aria-labelledby="payment-dialog"
      classes={{ paper: 'form-dialog' }}
    >
      <StyledDialogContainer>
        <StyledWarningContainer>
          <StyledWarningImg src="/alert.svg" alt="alert" />
        </StyledWarningContainer>
        <StyledTextContainer>
          <StyledH3>
            {getTranslatedString('tenantPortal.bamboraAutpayWarning.justHeadsUp')}
          </StyledH3>
          <StyledP>
            {paymentType === 'autopay'
              ? getTranslatedString('portalAutopay.setupAutopayWarning')
              : getTranslatedString('tenantPortal.bamboraAutpayWarning.leaseHasPreauth')}
          </StyledP>
        </StyledTextContainer>
        <StyledFormCtaContainer>
          <FlatButton onClick={handleCancel} style={{ color: AccentColor() }}>
            {getTranslatedString('tenantPortal.bamboraAutpayWarning.cancel')}
          </FlatButton>
          <FlatButton
            type="submit"
            variant="contained"
            style={{
              color: 'white',
              backgroundColor: AccentColor(),
            }}
            onClick={handleContinue}
          >
            {getTranslatedString('tenantPortal.bamboraAutpayWarning.continue')}
          </FlatButton>
        </StyledFormCtaContainer>
      </StyledDialogContainer>
    </Dialog>
  );
};

export default AutopaySetupWarning;
